"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WYRE_MAIN_ACCOUNT = exports.PORYGON2_STATUS = exports.UNAVAILABLE_STATES = void 0;
exports.UNAVAILABLE_STATES = {
    NY: 'New York',
    NH: 'New Hampshire',
    CT: 'Connecticut',
    HI: 'Hawaii',
    TX: 'Texas',
    VT: 'Vermont',
    VA: 'Virginia',
};
exports.PORYGON2_STATUS = {
    UNVERIFIED: 'UNVERIFIED',
    PENDING: 'PENDING',
    ID_REJECTED: 'ID_REJECTED',
    ADDRESS_REJECTED: 'ADDRESS_REJECTED',
    INFO_REJECTED: 'INFO_REJECTED',
    PAYMENT_METHOD_MISSING: 'PAYMENT_METHOD_MISSING',
    VERIFIED: 'VERIFIED',
};
exports.WYRE_MAIN_ACCOUNT = 'WYRE_MAIN_ACCOUNT';
